import { useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let productOptions = [];
let supplierDateOptions = [];
function SupplierProductTableRow({ key, companyProductList, supplierDates, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [productLoaded, setProductLoaded] = useState(false);
	const [productSelected, setProductSelected] = useState({ name: "companyProductKey", label: "", value: 0 });
	const [supplierDateLoaded, setSupplierDateLoaded] = useState(false);
    const [supplierDatesSelected, setSupplierDatesSelected] = useState([]);
	const [isSubmit, setIsSubmit] = useState(false);

	useEffect(() => {
		setCompanyProductValues(companyProductList);
		setSupplierDates(supplierDates);
	}, []);


	function setCompanyProductValues(productObj) {
		let productValue = {};
		productOptions = [];
		productOptions.push({ label: "", value: 0 });
		if (productObj && productObj.length > 0) {
			productObj.map((aProduct, index) => {
				productValue.label = aProduct.commodityName + ", " + aProduct.productName + (aProduct.productSku ? (", " + aProduct.productSku) : "");
				productValue.value = aProduct.companyProductKey;
				productOptions.push(productValue);
				productValue = {};
			});

		}
		setProductSelected({ ...productSelected, label: "", value: 0 });
		setProductLoaded(true);
	}


	const productHandler = (selectedOption, action) => {
		let companyProductKey = selectedOption ? selectedOption.value : 0;
		let productName = selectedOption ? selectedOption.label : "";
		productSelected.value = companyProductKey;
		setProductSelected({ ...productSelected, label: (productName), value: companyProductKey });
	}
	function setSupplierDates(supplierDatesList) {
        let supplierDateValue = {};
        supplierDateOptions = [];
        if (supplierDatesList && supplierDatesList.length > 0) {
            supplierDatesList.map((aSupplierDate, idx) => {
                supplierDateValue.label = aSupplierDate.startDate + " - " + aSupplierDate.endDate;
                supplierDateValue.value = aSupplierDate.partnershipDateKey;
                supplierDateOptions.push(supplierDateValue);
                supplierDateValue = {};
            });
            setSupplierDateLoaded(true);
        }
    }
    const supplierDateHandler = (selectedOptions) => {
		//console.log(selectedOptions);
        setSupplierDatesSelected(selectedOptions);
    }
	function submitComplete() {
		setIsSubmit(false);
		setSupplierDatesSelected([]);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let initialValues = {
			companyProductKey: 0,
			partnershipDateKeys: supplierDatesSelected.map(option => option.value),
		};
		const selectedProduct = companyProductList.find(aProduct => aProduct.companyProductKey === productSelected.value);
		if (selectedProduct) {
			initialValues.companyProductKey = selectedProduct.companyProductKey;
		}

		if (!selectedProduct.companyProductKey || selectedProduct.companyProductKey === 0) {
			setError(t("error.prodName.Reqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
		setSupplierDatesSelected([]);
	}
	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>

				{(productLoaded) ? <Select
					name="companyProductKey"
					options={productOptions}
					onChange={productHandler}
					placeholder={""}
					value={productSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="companyProductKey-input"
					styles={ddStyles}
				/> : <></>
				}
			</td>

			<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {supplierDateLoaded ? <Select
                    name="supplierDateKey"
                    options={supplierDateOptions}
                    onChange={supplierDateHandler}
                    placeholder={""}
                    value={supplierDatesSelected}
                    isSearchable={true}
                    isClearable={true}
                    className="myselect"
                    inputId="supplierDateKey-input"
                    isMulti
                    styles={ddStyles}
                />
                : <></>}
            </td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(productOptions && productOptions.length > 0) ?
					(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
					:
					(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default SupplierProductTableRow;